export const PAGES_MENU = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',  // path for our page
        data: { // custom menu declaration
          menu: {
            title: 'Dashboard', // menu title
            icon: 'ion-grid', // menu icon
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: 'mylistings',  // path for our page
        data: { // custom menu declaration
          menu: {
            title: 'My Listings', // menu title
            icon: 'ion-android-home', // menu icon
            selected: false,
            expanded: false,
            order: 0,
            roles: ['admin', 'agent']
          }
        }
      },
      {
        path: 'admin',  // path for our page
        data: { // custom menu declaration
          menu: {
            title: 'Admin', // menu title
            icon: 'ion-wrench', // menu icon
            selected: false,
            expanded: true,
            order: 0,
            roles: ['admin']
          }
        },
        children: [
          {
            path: 'alllistings',  // path for our page
            data: { // custom menu declaration
              menu: {
                title: 'All Listings', // menu title
                //icon: 'ion-android-home', // menu icon
                selected: false,
                expanded: false,
                order: 0,
                roles: ['admin']
              }
            }
          }
        ]
      },
      {
        path: 'listing',  // path for our page
        data: { // custom menu declaration
          menu: {
            title: 'Listing Details', // menu title
            icon: 'ion-android-home', // menu icon
            selected: false,
            expanded: false,
            pathMatch: 'prefix',
            order: 1,
            hidden: true
          }
        }
      },
      {
        path: 'offer',  // path for our page
        data: { // custom menu declaration
          menu: {
            title: 'Offer Details', // menu title
            icon: 'ion-android-home', // menu icon
            selected: false,
            expanded: false,
            pathMatch: 'prefix',
            order: 2,
            hidden: true
          }
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/pages/pages.menu.ts